import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  id: any;
}

const initialState: AuthState = {
  id: null,
};

const swapCourseSlice = createSlice({
  name: 'swapCoursesSlice',
  initialState,
  reducers: {
    setSwapCourses: (state, action: PayloadAction<any>) => {
      state.id = action.payload;
    },
    clearSetSwapCourses: state => {
      state.id = null;
    },
  },
});

export const { setSwapCourses, clearSetSwapCourses } = swapCourseSlice.actions;
export default swapCourseSlice.reducer;